import DOMPurify from 'dompurify';

// ==============================|| HTML / SVG SANITISATION HELPERS ||============================== //
//
// The application renders a small amount of server-supplied markup (QR code SVGs, and the
// FAQ / Terms rich-text documents). Any of that markup is attacker-influenced if the API is
// ever compromised or if a lower-privileged user can write to those records, so it must be
// sanitised before it reaches the DOM rather than trusted implicitly.

/**
 * Sanitise an SVG fragment for rendering via dangerouslySetInnerHTML.
 * Keeps SVG shape/markup but strips <script>, event handlers (onload, onerror, ...)
 * and javascript: URLs.
 *
 * @param {string} svg raw SVG markup from the API
 * @returns {string} sanitised markup, or '' when the input is not a string
 */
export function sanitizeSvg(svg) {
  if (typeof svg !== 'string' || svg === '') return '';
  return DOMPurify.sanitize(svg, {
    USE_PROFILES: { svg: true, svgFilters: true }
  });
}

/**
 * Extract plain text from an HTML string.
 *
 * The previous implementation assigned the raw HTML to `element.innerHTML` before reading
 * `textContent`. Even on a detached element that parses the markup, so payloads such as
 * `<img src=x onerror=alert(1)>` still execute. DOMParser never runs scripts or fires
 * resource-load handlers, so it is safe for this purpose.
 *
 * @param {string} html raw HTML from the API
 * @returns {string} the plain-text content
 */
export function htmlToPlainText(html) {
  if (typeof html !== 'string' || html === '') return '';
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body ? doc.body.textContent || '' : '';
}
